require('dotenv').config();
const Cryptr = require('../crypter/cryptr').default;

const encrypter = new Cryptr(process.env.REACT_APP_ENCRYPT_C_SECRET,
  {
    pbkdf2Iterations: parseInt(process.env.REACT_APP_ENCRYPT_ITERATIONS),
    saltLength: parseInt(process.env.REACT_APP_ENCRYPT_SALT)
  });

const decrypter = new Cryptr(process.env.REACT_APP_ENCRYPT_S_SECRET,
  {
    pbkdf2Iterations: parseInt(process.env.REACT_APP_ENCRYPT_ITERATIONS),
    saltLength: parseInt(process.env.REACT_APP_ENCRYPT_SALT)
  });

const cryptr_encrypt = () => {
  return encrypter
}
const cryptr_decrypt = () => {
  return decrypter
}

export {
  cryptr_encrypt,
  cryptr_decrypt
}